var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-temp',{attrs:{"widgetTitle":_vm.$t('charts.order_status_title'),"widgetName":"OrderStatusChart","widgetId":4}},[_c('template',{slot:"widget-content"},[_c('div',{staticClass:"chart-container"},[_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }